import { Component, OnInit, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { socialsConfigState } from '../store-provider';

@Component({
  standalone: false,
  selector: 'exceptions-block',
  templateUrl: './exceptions.component.html',
  styleUrls: ['./exceptions.component.scss']
})
export class ExceptionsComponent implements OnInit {
  @Input() error: any;

  showSocial: boolean = true;
  facebook = '';
  linkedin = '';
  twitter = '';
  youtube = '';
  errorPageType = '';
  errorPageTitle = '';
  errorPageSubtitle = '';
  errorhref = '';

  readonly errorPageSocialLinksTitle = $localize`:@@exceptions-component.errorPageSocialLinksTitle:Check out our social media channels in the meantime`;
  readonly errorIconPath = '/assets/images/svg_ico/icons.svg#error_';

  private socialState$: Observable<any>;

  constructor(private readonly store: Store<any>) {}

  ngOnInit() {
    this.socialState$ = this.store.pipe(select(socialsConfigState));
    this.socialState$.subscribe(response => {
      this.showSocial = true;

      this.facebook = response['socialLinks'].facebook;
      this.linkedin = response['socialLinks'].linkedin;
      this.twitter = response['socialLinks'].twitter;
      this.youtube = response['socialLinks'].youtube;
    });

    this.getErrorDetails(this.error);
  }

  getErrorDetails(error) {
    switch (Number(error)) {
      case 404:
        this.errorPageType = $localize`:@@exceptions.components.errorPageType404:Page not found`;
        this.errorPageTitle = $localize`:@@exceptions.components.errorPageTitle404:
        Sorry, looks like the page you're trying to reach has not been found`;
        this.errorPageSubtitle = $localize`:@@exceptions.components.errorPageSubtitle404:
        Make sure that the website URL in the address bar of your browser is spelled and formatted correctly.
        <br> The content might have been moved or may no longer be available.`;
        this.errorhref = this.errorIconPath + this.error;
        break;

      case 403:
        this.errorPageType = $localize`:@@exceptions.components.errorPageType403:Forbidden`;
        this.errorPageTitle = $localize`:@@exceptions.components.errorPageTitle403:No access to the page`;
        this.errorPageSubtitle = $localize`:@@exceptions.components.errorPageSubtitle403:
        Oops...it seems the URL you are trying to reach is inaccessible.`;
        this.errorhref = this.errorIconPath + this.error;
        break;

      case 500:
        this.errorPageType = $localize`:@@exceptions.components.errorPageType500:Internal server error`;
        this.errorPageTitle = $localize`:@@exceptions.components.errorPageTitle500:Sorry, it's not you.It's us, but we're on it.`;
        this.errorPageSubtitle = $localize`:@@exceptions.components.errorPageSubtitle500:
        Don't worry, our best people have been automatically notified of this issue and they are working on it.
        Please try again in a few minutes.`;
        this.errorhref = this.errorIconPath + this.error;
        break;

      default:
        break;
    }
  }
}
